import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';

const ThemeSwitch = () => {
  const [isDark, setIsDark] = useState(true);

  // Initialize theme from localStorage or default to dark
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const initialIsDark = savedTheme ? savedTheme === 'dark' : true;
    setIsDark(initialIsDark);
    applyTheme(initialIsDark);
  }, []);

  const applyTheme = (dark) => {
    const root = document.documentElement;
    
    if (dark) {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.add('light');
      root.classList.remove('dark');
    }
  };

  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
    applyTheme(newIsDark);
  };

  return (
    <motion.button
      onClick={toggleTheme}
      className="relative p-2.5 rounded-xl theme-switch-btn backdrop-blur-xl transition-all duration-300 cursor-pointer overflow-hidden"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Background glow */}
      <motion.div
        className="absolute inset-0 theme-switch-glow rounded-xl"
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.6, 0.3]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      
      {/* Icon container */}
      <motion.div
        key={isDark ? 'dark' : 'light'}
        initial={{ rotate: -180, opacity: 0, scale: 0.5 }}
        animate={{ rotate: 0, opacity: 1, scale: 1 }}
        exit={{ rotate: 180, opacity: 0, scale: 0.5 }}
        transition={{ duration: 0.6, ease: "backOut" }}
        className="relative w-5 h-5 flex items-center justify-center"
      >
        {isDark ? (
          <Moon size={16} className="theme-switch-icon" />
        ) : (
          <Sun size={16} className="theme-switch-icon" />
        )}
      </motion.div>
      
      {/* Subtle border glow */}
      <motion.div
        className="absolute inset-0 rounded-xl border theme-switch-border"
        animate={{
          borderColor: [
            "rgba(255, 255, 255, 0.1)",
            "rgba(255, 255, 255, 0.3)",
            "rgba(255, 255, 255, 0.1)"
          ]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.button>
  );
};

export default ThemeSwitch;
